import React from 'react';
import { RegionDropdown } from 'react-country-region-selector';

const RegionField = ({ label, error, country, handleChange, name, value, defaultLabel }) => {
	return (
		<div className="input-container" style={{ width: 'calc(50% - 6px)', marginRight: '12px' }}>
			<div className={`input ${error && 'input--error'}`}>
				{label && <span className="styledLabel styledLabel--active">{label}</span>}
				<div className="input--customSelect">
					<RegionDropdown
						country={country ? country.toUpperCase() : 'US'}
						countryValueType={'short'}
						valueType={'short'}
						defaultOptionLabel={defaultLabel}
						value={value}
						autoComplete="address-level1"
						classes="input--select overflowed-select"
						name={name}
						onChange={(e) => {
							handleChange(e);
						}}
					/>
				</div>
			</div>
			{error && (
				<div className="formError" style={{ marginTop: '4px' }}>
					{error}
				</div>
			)}
		</div>
	);
};

export default RegionField;
